import { render, staticRenderFns } from "./SupplierView.vue?vue&type=template&id=61baf154&scoped=true"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"
import style0 from "./SupplierView.vue?vue&type=style&index=0&id=61baf154&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61baf154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61baf154')) {
      api.createRecord('61baf154', component.options)
    } else {
      api.reload('61baf154', component.options)
    }
    module.hot.accept("./SupplierView.vue?vue&type=template&id=61baf154&scoped=true", function () {
      api.rerender('61baf154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/SupplierView.vue"
export default component.exports